import { createContext } from 'react';
import { LocCtx } from '../../types';

export const LocalizationContext = createContext<LocCtx>({} as LocCtx);
